import Dashboard from 'pages/dashboard';
import React from 'react';

export default function DashboardView() {
  return <Dashboard />;
}
